import * as toastr from "toastr";
import StaticSingleton from "../Shared/StaticSingleton";
import { ReloadApp } from "../../presentation/App";
import { DisplayToastrError } from "source/app/presentation/Shared/HandleError";

class WorkboxCache extends StaticSingleton<WorkboxCache> {
    Clear = (timeOut: number = 2000) =>
        caches
            .keys()
            .then((keys) => keys.filter((key) => key.includes(`workbox`)))
            .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
            .then((any) => setTimeout(() => ReloadApp(), timeOut))
            .catch((error) => DisplayToastrError(error, "Workbox cache error"));
}

export default new WorkboxCache();
